import React, { Component } from 'react';
import { Button, Toast, WhiteSpace, Picker, List, Modal } from 'antd-mobile';
import { Icon } from 'antd';
import { CommonlyHeadMembers } from '../../common/headnav';
import { AddPeople } from "../../common/addpeople";
import * as services from '../../projects/services';
import AddCalendar from "../../../components/addcalendar";
import { createBrowserHistory } from "history";
import './style.less';
const history = createBrowserHistory();
export default class Addorderment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal1: false,
            add: [],
            cardid: this.props.match.params.cardid,
            orderid: this.props.match.params.orderid,
            opid: this.props.match.params.opid,
            integral: [],
            peoplelist: [],
            peoplelist2: [],
            hospitallist: [],
            orderdetail: {},
            timeList: [],
            timeList2: [],
            mcData: [],
            colorValue: 0,
            visible: false,
            ishow: true,
            mprice: 0,
            packagename: '',
            ishow2: true,
            mcid: 0,
            peopleId: 0,
            params: {
                mcno: '',
                examdate: '',
                timeid: '',
                packageid: '',
                packagename: '',
                packageType: '',
                ids: '',
                publicIds: '',
                payType: 4,
                isnetreport: '',
                ispagerreport: '',
                peopleId: '',
                peopleisUse: true,
                peopleSex: '0',
                breceipt: false,
                addressId: '',
            },
        }
    }
    GetPeopleList(isnewAdd) {
        let opid = !!this.props.match.params.opid ? this.props.match.params.opid : '';
        services.GetPeopleList(opid, '').then(data2 => {
            if (data2.status === 0) {
                if (!!data2.result) {
                    const arr1 = data2.result.map(function (item, index) {
                        let obj = {};
                        obj = {
                            value: item.peopleid,
                            peopleisUse: item.isUse,
                            peopleSex: parseInt(item.sex),
                            message: !!item.message ? item.message : '',
                            fullname: item.fullname,
                            label:
                                (<div key={index}>
                                    <span style={{ color: !!item.isUse ? '' : '#ccc' }}>{item.fullname}</span>
                                </div>),
                        };
                        return obj;
                    })
                    this.setState({ peoplelist: arr1 });
                    let cm2 = [];
                    if (!localStorage.getItem('peopleInfo') && arr1.length > 0) {

                        cm2.push(parseInt(arr1[0].value));
                        let params = this.state.params;
                        params.peopleId = cm2;
                        localStorage.setItem('peopleInfo', JSON.stringify(arr1[0]));
                        this.setState({ peopleId: cm2, params: params, peopleisUse: parseInt(arr1[0].peopleisUse), peopleSex: parseInt(arr1[0].peopleSex) });
                    } else {
                        if (isnewAdd === 1) {
                            cm2.push(parseInt(arr1[arr1.length - 1].value));
                            let params = this.state.params;
                            params.peopleId = cm2;
                            let peopleInfo = JSON.parse(localStorage.getItem('peopleInfo'));
                            if (parseInt(peopleInfo.peopleSex) !== parseInt(arr1[arr1.length - 1].peopleSex)) {
                                params.packageid = 0;
                                params.packageType = 0;
                                params.ids = '';
                                params.packagename = '';
                                params.timeid = 0;
                                params.examdate = '';
                                params.peopleisUse = arr1[arr1.length - 1].peopleisUse;
                                params.peopleSex = arr1[arr1.length - 1].peopleSex;
                                this.setState({ ishow: false, packagename: '', mprice: 0 });
                            }
                            localStorage.setItem('peopleInfo', JSON.stringify(arr1[arr1.length - 1]));
                            this.setState({ peopleId: cm2, params: params, peopleisUse: parseInt(arr1[arr1.length - 1].peopleisUse), peopleSex: parseInt(arr1[arr1.length - 1].peopleSex) });
                        }
                    }
                }
            } else {
                Toast.offline(data2.message);
            }
        });
    }
    componentDidMount() {
        this.GetPeopleList(0);
        if (parseInt(this.state.cardid) !== 0) {
            services.GetIntegralD(this.state.cardid, '').then(data => {
                if (data.status === 0) {
                    if (!!data.result) {
                        let integral = data.result;
                        this.setState({ integral: integral });
                    }
                } else {
                    Toast.offline(data.message);
                }
            });
            services.GetUnionListpublic(this.state.cardid, '').then(data3 => {

                if (!data3.result.isdestination) {
                    services.GetUnionListpublic2('').then((data4 => {
                        if (data4.status === 0) {
                            if (!!data4.result) {
                                const arr1 = data4.result.map(function (item) {
                                    let obj = {};
                                    obj.value = item.unionCode;
                                    obj.label = item.unionName;
                                    return obj
                                })
                                this.setState({ hospitallist: arr1 });
                            }

                        } else {
                            Toast.offline(data4.message);
                        }
                    }));

                } else if (!!data3.result.children) {

                    const arr1 = data3.result.children.map(function (item) {
                        let obj = {};
                        obj.value = item.unionCode;
                        obj.label = item.unionName;
                        return obj
                    })
                    this.setState({ hospitallist: arr1 });
                }
            });


        }
        if (parseInt(this.state.orderid) !== 0) {
            //查询订单详情            
            let orderdetail = JSON.parse(localStorage.getItem('orderment_order'));
            this.setState({ orderdetail: JSON.parse(localStorage.getItem('orderment_order')) });
            let params = this.state.params;
            params.mcno = orderdetail.mcno;
            services.GetJsonExamDate(orderdetail.mcno, '').then(mdata => {
                if (mdata.status === 0) {
                    if (!!mdata.result) {
                        this.setState({ mcData: mdata.result.sc, ishow2: false }, () => {
                        });
                    }
                } else {
                    Toast.offline(mdata.message);
                }
            })
        }
        if (localStorage.getItem('peopleInfo') !== null) {
            let peopleInfo = JSON.parse(localStorage.getItem('peopleInfo'));
            let params = this.state.params;
            params.peopleSex = peopleInfo.peopleSex;
            params.peopleisUse = peopleInfo.peopleisUse;
            let cm2 = [];
            cm2.push(peopleInfo.value);
            params.peopleId = cm2;
            this.setState({ peopleId: cm2, params: params });
        }
        if (localStorage.getItem('orderment') !== null) {
            let orderment = JSON.parse(localStorage.getItem('orderment'));
            let params = this.state.params;
            let cm = [];
            cm.push(orderment.mcno);
            params.mcno = cm;
            params.packageid = orderment.packageid;
            params.ids = orderment.ids;
            params.packageType = orderment.packageType;
            let mprice = orderment.payprice === undefined ? 0 : orderment.payprice;
            services.GetJsonExamDate(cm, '').then(mdata => {
                if (mdata.status === 0) {
                    if (!!mdata.result) {
                        this.setState({ mcData: mdata.result.sc, ishow2: false }, () => {
                        });
                    }
                } else {
                    Toast.offline(mdata.message);
                }
            })
            this.setState({
                params: params, mprice: mprice, packagename: orderment.packagename, ishow: false
            });
        }

        if (localStorage.getItem('mcnoId') !== null) {
            let cm = [];
            cm.push(localStorage.getItem('mcnoId'));
            let params = this.state.params;
            params.mcno = cm;
            this.setState({ params: params, ishow: false });
        }

    }
    onChangeColor = () => {

    }
    onVisibleChange = (e) => {
    }
    onAdd = (e) => {
        this.setState({
            modal1: true, add: [],
        });
    }
    onClose = () => {
        this.setState({
            modal1: false,
        });
        this.GetPeopleList(1);
    }
    onTimeList = (e) => {
        var v = this.state.timeList2.find(value => parseInt(value.timeid) === parseInt(e[0]));
        if (parseInt(v.noUsedCount) === 0) {
            Toast.offline('该时间段已满，请选择其他时间', 2);
        } else {
            let params = this.state.params;
            if (params.mcno instanceof Array === false) {
                let cm = [];
                cm.push(params.mcno);
                params.mcno = cm;
            }
            params.timeid = e;
            this.setState({ params: params, ishow: false });
        }
    }
    onPeople = (e) => {
        localStorage.removeItem('peopleInfo');
        let params = this.state.params;
        var v = this.state.peoplelist.find(value => parseInt(value.value) === parseInt(e[0]));
        if (v.peopleisUse) {
            localStorage.removeItem('orderment');
            if (parseInt(this.state.params.peopleSex) !== parseInt(v.peopleSex)) {

                params.packageid = 0;
                params.packageType = 0;
                params.ids = '';
                params.packagename = '';
                params.peopleisUse = v.peopleisUse;
                params.peopleSex = v.peopleSex;
                params.peopleId = e;
                params.timeid = 0;
                params.examdate = '';
                this.setState({ params: params, ishow: false, packagename: '', mprice: 0, peopleId: e });
            } else {

                params.peopleisUse = v.peopleisUse;
                params.peopleSex = v.peopleSex;
                params.peopleId = e;
                this.setState({ params: params, peopleId: e });
            }
            localStorage.setItem('peopleInfo', JSON.stringify(v));
        } else {
            Toast.info(v.message, 2);
        }
    }
    onHospital = (e) => {
        let params = this.state.params;
        localStorage.removeItem('orderment');
        localStorage.setItem('mcnoId', e);
        params.mcno = e;
        params.packageid = 0;
        params.packageType = 0;
        params.ids = '';
        params.packagename = '';
        params.timeid = 0;
        params.examdate = '';
        this.setState({ params: params, ishow: false, packagename: '', mprice: 0 });
        services.GetJsonExamDate(e, '').then(mdata => {
            if (mdata.status === 0) {
                if (!!mdata.result) {
                    this.setState({ mcData: mdata.result.sc, ishow2: false }, () => {
                    });
                }
            } else {
                Toast.offline(mdata.message);
            }
        })
    }
    onOpenData = (e) => {
        let params = this.state.params;
        if (params.mcno instanceof Array === false) {
            let cm = [];
            cm.push(params.mcno);
            params.mcno = cm;
        }
        this.setState({ params: params, visible: true });
    }

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };
    getChildData = (res, value) => {
        let params = this.state.params;
        params.timeid = 0;
        params.examdate = value;
        this.setState({
            visible: false,
            examdate: params
        });
        let params2 = { mcno: this.state.params.mcno, examDate: value };
        services.GetScheduleTimesSche(params2, '').then(item => {
            if (item.status === 0) {
                if (!!item.result) {
                    const data = item.result.map(function (item) {
                        let obj = {};
                        obj.value = item.timeid;
                        // let num = item.isShow ? '余' + item.noUsedCount : item.noUsedCountName;
                        // obj.label = item.mintime + '-' + item.maxtime + '(' + num + ')';
                        obj.label = item.mintime + '-' + item.maxtime;
                        return obj
                    })
                    this.setState({ timeList: data, timeList2: item.result });
                }

            }
        })

    }
    onPackage = () => {
        //判断体检中心是否有套餐

        //医院编号、卡号、applyid、
        if (!this.state.params.mcno) {
            Toast.offline('请先选择体检中心', 2);
            return false;
        }
        if (!this.state.params.peopleId) {
            Toast.offline('请先选择体检人', 2);
            return false;
        }
        services.GetHospitalItem(this.state.params.mcno, '').then(value => {
            if (value.status === 0) {
                if (value.result.packCount > 0) {
                    history.push(`/members/orderment/pack/${this.state.params.mcno}/${this.state.integral.applyid}/${this.state.integral.clientid}/${this.state.cardid}/${this.state.peopleId}`);
                    history.go();
                }else{
                    Toast.offline('当前体检中心暂未开通线上预约功能，请选择其他体检中心!', 3);
                }
            };
        })
    }
    onchan = () => {
    }
    onHorbut = () => {

        if (parseInt(this.state.orderid) !== 0) {
            let params2 = {
                "creId": this.state.orderdetail.credentialid,
                "examdate": "",
                "timeid": 0,
                "peopleId": 0
            }
            let params = this.state.params;

            if (!!params.peopleId === false || params.peopleId === '') {
                Toast.offline('请选择要体检的人员！', 1);
                return false;
            }
            params.peopleId = !!params.peopleId[0] ? params.peopleId[0] : params.peopleId;
            var v = this.state.peoplelist.find(value => parseInt(value.value) === parseInt(params.peopleId));
            if (!!v.fullname === false || v.fullname === '') {
                Toast.offline('您的体检人名字有误，请去体检人管理去修改！');
                return false;
            }
            if (!!params.examdate === false || params.examdate === '') {
                Toast.offline('请选择预约时间！', 1);
                return false;
            }
            if (!!params.timeid === false || params.timeid === '') {
                Toast.offline('请选择体检时间段！', 1);
                return false;
            }
            params2.timeid = !!params.timeid[0] ? params.timeid[0] : params.timeid;
            params2.peopleId = !!params.peopleId[0] ? params.peopleId[0] : params.peopleId;
            params2.examdate = params.examdate;
            this.setState({ ishow: true });
            services.AddOrdermentAppointment(params2, '').then((data) => {
                let params_first = {
                    mcno: '',
                    examdate: '',
                    timeid: '',
                    packageid: '',
                    packagename: '',
                    packageType: '',
                    ids: '',
                    publicIds: '',
                    payType: 4,
                    isnetreport: '',
                    ispagerreport: '',
                    peopleId: '',
                    breceipt: false,
                    addressId: '',
                }
                if (data.status === 0) {
                    this.setState({ params: params_first, ishow: true, packagename: '', mprice: 0 });
                    Toast.success(data.message, 3, () => {
                        localStorage.removeItem('orderment');
                        localStorage.removeItem('peopleId');
                        localStorage.removeItem('mcnoId');
                        history.push('/members/orderment/1');
                        history.go();
                    });

                } else {
                    Toast.offline(data.message);
                }
            })
        } else {
            let params = this.state.params;
            if (!!params.peopleId === false || params.peopleId === '') {
                Toast.offline('请选择要体检的人员！');
                return false;
            }
            params.peopleId = !!params.peopleId[0] ? params.peopleId[0] : params.peopleId;
            var vpeople = this.state.peoplelist.find(value => parseInt(value.value) === parseInt(params.peopleId));
            if (!!vpeople.fullname === false || vpeople.fullname === '') {
                Toast.offline('您的体检人名字有误，请去体检人管理去修改！');
                return false;
            }
            if (!!params.mcno === false || params.mcno === '' || params.mcno === 0) {
                Toast.offline('请选择体检中心！');
                return false;
            }
            if (!!params.packageid === false && parseInt(params.packageType) !== 1) {
                Toast.offline('请选择要预约的套餐！');
                return false;
            }
            if (!!params.examdate === false || params.examdate === '') {
                Toast.offline('请选择预约时间！', 1);
                return false;
            }
            if (!!params.timeid === false || params.timeid === '') {
                Toast.offline('请选择体检时间段！', 1);
                return false;
            }
            let m = !!(params.mcno[0]) ? params.mcno[0] : params.mcno;
            params.mcno = m;
            params.timeid = !!params.timeid[0] ? params.timeid[0] : params.timeid;
            params.publicIds = this.state.cardid;
            this.setState({ ishow: true });
            services.AddOrderment(params, '正在新增，请稍后').then(data => {
                this.setState({ ishow: false });
                let params_first = {
                    mcno: '',
                    examdate: '',
                    timeid: '',
                    packageid: '',
                    packagename: '',
                    packageType: '',
                    ids: '',
                    publicIds: '',
                    payType: 4,
                    isnetreport: '',
                    ispagerreport: '',
                    peopleId: '',
                    breceipt: false,
                    addressId: '',
                }
                if (data.status === 0) {
                    this.setState({ params: params_first, ishow: true, packagename: '', mprice: 0 });
                    localStorage.removeItem('orderment');
                    localStorage.removeItem('peopleId');
                    localStorage.removeItem('mcnoId');
                    Toast.success('预约成功！', 1, () => {
                        if (data.result.isEditPayment === true) {
                            history.push(`/pay/` + data.result.orderId);
                            history.go();
                        } else {
                            window.location.href = global.constants.tj_tijian + '/pay/wap?OrderID=' + data.result.orderId;
                        }
                    });

                } else {
                    Toast.offline(data.message);
                }
            });
        }
    }
    render() {
        const { peoplelist, hospitallist, peopleId, timeList, integral, params, mcData, orderdetail } = this.state;

        return <div className="addorderment">
            <CommonlyHeadMembers barname="体检预约" />
            {
                parseInt(this.state.orderid) === 0 ?
                    <List>
                        <List.Item>
                            <span className="name">积分编号：</span><input type="text" disabled defaultValue={integral.cardcode} />
                        </List.Item>
                        <List.Item>
                            <span className="name">积分余额：</span><input type="text" className="colora" disabled defaultValue={integral.cardmoney} />
                        </List.Item>
                        {
                            !!peoplelist ?
                                <List.Item className="pickerDiv" >
                                    <div className="pdiv">
                                        <Picker
                                            data={peoplelist}
                                            value={peopleId}
                                            cols={1}
                                            onChange={this.onPeople}
                                            title="选择体检人"
                                        >
                                            <List.Item arrow="horizontal" className="shortPicker" >体检人:</List.Item>
                                        </Picker>
                                    </div>
                                    <button className="pickerBut" onClick={this.onAdd} >添加</button>
                                </List.Item>
                                :
                                <List.Item>
                                    <span className="name">体检人：</span><button className="pickerBut" onClick={this.onAdd} >添加体检人</button>
                                </List.Item>
                        }
                        <Picker
                            data={hospitallist}
                            value={params.mcno}
                            cols={1}
                            onChange={this.onHospital}
                        >
                            <List.Item arrow="horizontal" >体检中心：</List.Item>
                        </Picker>
                        <List.Item><span className="name">选择套餐：</span><input type="text" className="shortInput" style={{ textAlign: "right" }} placeholder="请选择套餐" value={this.state.packagename} disabled={this.state.ishow} onClick={this.onPackage} /><Icon type="shop" style={{ fontSize: '16px', color: '#32a128' }} /></List.Item>
                        <List.Item>
                            <span className="name">套餐价格：</span><input type="text" className="shortInput" disabled placeholder="0" value={this.state.mprice} />
                        </List.Item>
                        <List.Item><span>预约日期：</span>
                            <input type="text" className="shortInput" style={{ textAlign: "right" }} defaultValue={params.examdate} placeholder="请选择时间" disabled={this.state.ishow} onClick={this.onOpenData} /><Icon type="calendar" style={{ fontSize: '16px', color: '#32a128' }} onClick={this.state.ishow === true ? this.onchan : this.onOpenData} /></List.Item>

                        <Picker
                            data={timeList}
                            value={params.timeid}
                            cols={1}
                            onChange={this.onTimeList.bind(this)}
                            disabled={!!params.examdate === false ? true : false}

                        >
                            <List.Item arrow="horizontal" >预约时间：</List.Item>
                        </Picker>
                    </List>

                    :
                    <List>
                        <List.Item>
                            <span className="name">体检中心：</span><input type="text" disabled defaultValue={orderdetail.mcname} />
                        </List.Item>
                        <List.Item>
                            <span className="name">体检套餐：</span><input type="text" disabled defaultValue={orderdetail.title} />
                        </List.Item>
                        <List.Item>
                            <span className="name">套餐价格：</span><input type="text" style={{ color: '#f00' }} disabled defaultValue={orderdetail.price} />
                        </List.Item>
                        {
                            !!peoplelist ?
                                <List.Item className="pickerDiv" >
                                    <div className="pdiv">
                                        <Picker
                                            data={peoplelist}
                                            value={peopleId}
                                            cols={1}
                                            onChange={this.onPeople}
                                            title="选择体检人"

                                        >
                                            <List.Item key="cmd" arrow="horizontal" className="shortPicker" >体检人： </List.Item>
                                        </Picker>
                                    </div>
                                    <button className="pickerBut" onClick={this.onAdd} >添加</button>
                                </List.Item>
                                :
                                <List.Item>
                                    <span className="name">体检人：</span><button className="pickerBut" onClick={this.onAdd} >添加体检人</button>
                                </List.Item>
                        }
                        <List.Item><span>预约日期：</span><input type="text" className="shortInput" style={{ textAlign: "right" }} placeholder="请选择时间" defaultValue={params.examdate} onClick={this.onOpenData.bind(this)} /><Icon type="calendar" style={{ fontSize: '16px', color: '#32a128' }} onClick={this.state.ishow === true ? this.onchan : this.onOpenData} /></List.Item>
                        <Picker
                            data={timeList}
                            value={params.timeid}
                            cols={1}
                            onChange={this.onTimeList.bind(this)}
                            disabled={!!params.examdate === false ? true : false}
                        >
                            <List.Item arrow="horizontal" >预约时间：</List.Item>
                        </Picker>
                    </List>
            }
            <WhiteSpace />
            <Button type="green" className="horbut" disabled={this.state.ishow} onClick={this.onHorbut} >确定预约</Button>
            <WhiteSpace />
            <Modal
                title="排班日历"
                visible={this.state.visible}
                transparent
                maskClosable={true}
                onClose={this.handleOk}
                closable={true}      >
                {mcData.length > 0 ? <AddCalendar cm={mcData} new={this} isClickable={true} /> : ''}
            </Modal>

            <Modal
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            ><AddPeople onClose={this.onClose} data={this.state.add} />
            </Modal>
        </div>;
    }
}
